export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";